/* eslint-disable camelcase */
import Banner from '../../ui/Banner';
import { Testimony, Enum_Testimony_Type } from '../../../types/schema';
import UserTestimony from '../../ui/UserTestimony';

export type HomePageTemplateProps = {
  language: string;
  testimonies: Testimony[];
};

const HomePageTemplate: React.FC<HomePageTemplateProps> = ({ language, testimonies }) => {
  const isEn = language === 'en';

  testimonies = testimonies.map((testimony) => ({
    ...testimony,
    image: testimony.image,
  })) as Testimony[];

  return (
    <div>
      <Banner>{isEn ? 'Testimonials' : 'Depoimentos'}</Banner>
      {isEn ? (
        <UserTestimony
          testimonies={testimonies as Testimony[]}
          testimoniesType={'client' as Enum_Testimony_Type}
        />
      ) : (
        <>
          <UserTestimony
            title={'Clientes e casos de sucesso'}
            testimonies={testimonies as Testimony[]}
            testimoniesType={'client' as Enum_Testimony_Type}
          />
          <UserTestimony
            title={'Devs que fizeram parte da nossa equipe'}
            testimonies={testimonies as Testimony[]}
            testimoniesType={'employee' as Enum_Testimony_Type}
          />
        </>
      )}
    </div>
  );
};

export default HomePageTemplate;
